module.exports = __webpack_public_path__ + "static/media/helengeli-32.d83fb373.jpg";